import React from 'react';

// The trailing arrow of a button or row that goes on, as the app's chevron-right
const Chevron = () => (
  <svg className="form-chevron" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    <path d="m9 5 7 7-7 7" />
  </svg>
);

export default Chevron;
